import { useQuery } from 'react-query';
import { WorkOrderTrackingCalendarQueryParams } from './Tracking.types';
import {
  getWorkOrderTrackingCalendarComplement,
  listWorkOrdersTrackingCalendar,
} from './Tracking.service';
import notificationError from '@/utils/functions/notificationError';
import { queryClient } from '@/Root';

export function useWorkOrderTrackingCalendar(
  params?: WorkOrderTrackingCalendarQueryParams,
) {
  const cache = queryClient.getQueryData([
    'workOrders/tracking/calendar',
    { ...params },
  ]);

  return useQuery(
    ['workOrders/tracking/calendar', { ...params }],
    () => listWorkOrdersTrackingCalendar(params),
    {
      enabled:
        !!params?.dateType &&
        !!params?.startDate &&
        !!params?.endDate &&
        !cache,
      onError(error) {
        notificationError(error);
      },
    },
  );
}

export function useWorkOrderTrackingCalendarComplement(complementId?: number) {
  const cache = queryClient.getQueryData([
    'workOrders/tracking/calendar/complement',
    complementId,
  ]);

  return useQuery(
    ['workOrders/tracking/calendar/complement', complementId],
    () => getWorkOrderTrackingCalendarComplement(complementId),
    {
      enabled: !!complementId && !cache,
      onError(error) {
        notificationError(error);
      },
    },
  );
}
